import React from 'react';
import TopNav from '../../components/TopNav';
import CatchBlog from '../../images/catch/catch_blog.jpg';
import CatchBlog2x from '../../images/catch/catch_blog@2x.jpg';

const Header = () => {
  return (
    <header>
      <TopNav />
      <div className="catch sub">
        <img
          src={ CatchBlog }
          srcSet={ `${ CatchBlog } 1x, ${ CatchBlog2x } 2x` }
          alt="ドナー募集掲示板"
        />
      </div>
    </header>
  );
}

export default Header;
